/**
 * Yarn Tools Section Interactive Logic
 * Upload to: assets/yarn-tools-section.js
 */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function initSection(root) {
    if (!root || root.dataset.ytsInit === 'true') return;
    root.dataset.ytsInit = 'true';

    // 1. Intersection Observer for Smooth Reveal Animations
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.add('is-inview');
              root.classList.remove('is-offscreen');
            } else {
              root.classList.add('is-offscreen');
            }
          });
        },
        { threshold: 0.12 }
      );
      observer.observe(root);
    } else {
      root.classList.add('is-inview');
    }

    // 2. Subtle Interactive Pointer Parallax on the Overlapping Image Cards
    var parallaxLayer = root.querySelector('[data-yts-parallax]');
    var enableParallax = root.dataset.enableParallax === 'true';

    if (parallaxLayer && enableParallax && !reduceMotion && finePointer) {
      var ticking = false;
      var targetX = 0;
      var targetY = 0;

      function updateParallax() {
        ticking = false;
        parallaxLayer.style.setProperty('--yts-px', targetX.toFixed(2) + 'px');
        parallaxLayer.style.setProperty('--yts-py', targetY.toFixed(2) + 'px');
      }

      function requestTick() {
        if (!ticking) {
          window.requestAnimationFrame(updateParallax);
          ticking = true;
        }
      }

      root.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var rect = root.getBoundingClientRect();
        var normX = (e.clientX - rect.left) / rect.width - 0.5;
        var normY = (e.clientY - rect.top) / rect.height - 0.5;
        targetX = normX * -14;
        targetY = normY * -10;
        requestTick();
      });

      root.addEventListener('pointerleave', function () {
        targetX = 0;
        targetY = 0;
        requestTick();
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-yarn-tools]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Theme Customizer Support
  document.addEventListener('shopify:section:load', function (event) {
    var root =
      event.target.querySelector('[data-yarn-tools]') ||
      (event.target.matches('[data-yarn-tools]') ? event.target : null);
    if (root) {
      root.removeAttribute('data-yts-init');
      initSection(root);
    }
  });
})();
